import { render, staticRenderFns } from "./topSnakes.vue?vue&type=template&id=e1322170"
import script from "./topSnakes.vue?vue&type=script&lang=js"
export * from "./topSnakes.vue?vue&type=script&lang=js"
import style0 from "./topSnakes.vue?vue&type=style&index=0&id=e1322170&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports